import { cpuParser, memoryParser } from 'k8s-resource-parser'

export interface ParsedComputeResources {
  cpu: number
  memory: number
}

export const parseComputeResources = (
  cpu?: string | null,
  memory?: string | null
): ParsedComputeResources | undefined => {
  if (!cpu || !memory) return undefined

  try {
    const parsedCPU = cpuParser(cpu)
    const parsedMemory = memoryParser(memory)
    if (!Number.isFinite(parsedCPU) || !Number.isFinite(parsedMemory)) return undefined
    return { cpu: parsedCPU, memory: parsedMemory }
  } catch {
    return undefined
  }
}
